import {testIdProps} from '@github-ui/test-id-props'
import {Label, ToggleSwitch} from '@primer/react'
import {useCallback} from 'react'

import {useAgentAssignmentVisibility} from '../../features/copilot-tasks/use-agent-assignment-visibility'
import {ViewerPrivileges} from '../../helpers/viewer-privileges'
import type {BaseViewState, ViewIsDirtyStates} from '../../hooks/use-view-state-reducer/types'
import {PotentiallyDirty} from '../potentially-dirty'
import styles from './hierarchy-toggle.module.css'

export function AgentAssignmentToggle({view}: {view: BaseViewState & ViewIsDirtyStates}) {
  const {hasWritePermissions} = ViewerPrivileges()
  const {agentAssignmentVisible: visible, setAgentAssignmentVisible: setVisible} = useAgentAssignmentVisibility()

  const onClick = useCallback(() => {
    setVisible(view.number, !visible)
  }, [visible, setVisible, view.number])

  return (
    <div className={styles.toggleContainer}>
      <div className="d-flex align-items-center gap-2">
        <PotentiallyDirty
          isDirty={view.isAgentAssignmentVisibleDirty}
          hideDirtyState={!hasWritePermissions}
          {...testIdProps('agent-assignment-dirty')}
        >
          <div id="agent-assignment-visible-label">Show agent tasks</div>
        </PotentiallyDirty>
        <Label variant="success">Beta</Label>
      </div>
      <ToggleSwitch size="small" aria-labelledby="agent-assignment-visible-label" checked={visible} onClick={onClick} />
    </div>
  )
}
